export class TicketValidity {
  public static onFilterApplied(validityCode: string) {
    if(validityCode === '00') {
      return '&nbsp;';
    }
    return validityCode;
  }
}